export const monacoEditorTheme = 'vs-dark'
